import React, {useEffect, useState} from 'react';
import {Button, Form, Input, Modal, Radio, ConfigProvider, notification} from 'antd';
import Axios from "../../config/axiosConfig/axios";
import {Api} from "../../config/apiList/api";
const Frm = ({ open, onCreate, onCancel }) => {
    const [form] = Form.useForm();

    return (
        <ConfigProvider direction="rtl">
            <Modal style={{fontFamily: "iranSansBold"}}
                open={open}
                title="ارسال نوتیفیکیشن به کاربرها"
                okText="ذخیره تغییرات"
                cancelText="انصراف"
                onCancel={onCancel}
                closable={false}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreate(values);
                        })
                        .catch((info) => {
                        });
                }}
            >


                <Form
                    form={form}
                    layout="vertical"
                    name="form_in_modal"
                    initialValues={{

                        modifier: 'public',
                    }}
                >

                    <Form.Item name="title" label="عنوان" colon={false}
                               rules={[
                                   {
                                       required: true,
                                       message: 'لطفا عنوان را وارد کنید!',
                                   },
                               ]}
                    >
                        <Input type="text"/>
                    </Form.Item>

                    <Form.Item name="body" label="پیغام ارسالی" colon={false}
                               rules={[
                                   {
                                       required: true,
                                       message: 'لطفا پیغام را وارد کنید!',
                                   },
                               ]}
                    >
                        <Input.TextArea type="text"/>
                    </Form.Item>


                </Form>
            </Modal>
        </ConfigProvider>
    );
};

const NotifModal = (props) => {
    const [open, setOpen] = useState(false);

    const RedNotification = (text) => {
        notification.open({
            message: "اخطار",
            description: text,
            style: {
                background: "#F3585c",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }


    const onCreate = async (values) => {





        const data = {
            users: props.selectedRowKeys,
            title: values.title,
            body: values.body
        }


        await Axios.post("",`${Api}sendnotif`, data
        )
            .then(async (data) => {
                if (data.statusCode === 200 || data.statusCode === 201) {
                    await notification.open({
                        message: "موفقیت",
                        description: "درخواست با موفقیت انجام شد!",
                        style: {
                            background: "#43a047",
                            color: "white",
                            fontFamily: "IRANSansMobileFaNum",
                            borderRadius: "5px",
                        }
                    })
                }
                else {
                    await notification.open({
                        message: "اخطار",
                        description: "پیغام ارسال نشد لطفا بعدا تلاش کنید!",
                        style: {
                            background: "#8db5f5",
                            color: "white",
                            fontFamily: "IRANSansMobileFaNum",
                            borderRadius: "5px",
                        }
                    })
                }

            })
            .catch((error) => {
            });
        // // console.log('Received values of form: ', values);
        await setOpen(false);
    };
    return (
        <div>
            <Button
                type="primary"
                onClick={() => {
                    setOpen(true);
                }} disabled={!props.hasSelected}
                style={{fontFamily: "iranSansBold", fontSize: "15px"}}
            >
                 پیغام

            </Button>
            <Frm isLogin={props.listId}
                             open={open}
                             onCreate={onCreate}
                             onCancel={() => {
                                 setOpen(false);
                             }}
            />
        </div>
    );
};
export default NotifModal;